import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../../services/Toast.service";
import {NewTpiqService} from "../../../tpiq-services/new-tpiq.service";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {Session} from "../../../services/Session";
import {TpiqCustomDatepicker} from "../../../directives/tpiq-custom-datepicker";
import {FroalaEditorModule, FroalaViewModule} from "angular-froala-wysiwyg";
import { environment } from '../../../../environments/environment';

declare const _: any;
declare const moment: any;

@Component({
  selector: 'app-create-or-update-announcement',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqCustomDatepicker, FroalaEditorModule, FroalaViewModule],
  templateUrl: './create-or-update-announcement.component.html',
  styleUrl: './create-or-update-announcement.component.scss'
})
export class CreateOrUpdateAnnouncementComponent implements OnInit, OnDestroy {
  @Input() editMode: any;
  @Input() announcementId: any;
  @Output() onCancelCreateOrUpdateOfAnnouncement: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCreationOrUpdateOfAnnouncement: EventEmitter<any> = new EventEmitter<any>();
  org: string = Session.getOrg();
  user: any = {};
  anouncement: any = {
    noOfTimesToDisplay: 1
  };
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  editorOptions = {
    heightMin: 100,
    heightMax: 120,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Enter description here...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };
  currentDate: any;

  constructor(
    private loadingService: LoadingService,
    private toastService: ToastService,
    private newTpiqService: NewTpiqService
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();
    this.currentDate = moment().format('MM/DD/YYYY');
    if (this.editMode) {
      this.getAnouncementData();
    } else {
      this.anouncement = {
        noOfTimesToDisplay: 1
      };
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getAnouncementData() {
    this.loadingService.triggerLoadingEvent(true);
    this.newTpiqService.getAnouncement(this.org, this.user.id, this.announcementId)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.anouncement = _.cloneDeep(response) || {};
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to get anouncement data`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  setAnouncementDate($event, type) {
    if (type == 'start') {
      this.anouncement.startDate = $event;
    } else if (type == 'end') {
      this.anouncement.endDate = $event;
    }
  }

  closeCreateOrUpdatePopup() {
    this.onCancelCreateOrUpdateOfAnnouncement.emit();
  }

  saveAnouncement(){
    if (!this.validateData()){
      return;
    }
    this.loadingService.triggerLoadingEvent(true);
    this.newTpiqService.createOrEditAnouncement(this.org, this.user.id, this.anouncement)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        const successMsg = (this.editMode) ? 'Updated successfully' : 'Created successfully';
        this.toastService.pop(TOAST_TYPE.success, successMsg);
        this.onCreationOrUpdateOfAnnouncement.emit();
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed To save anouncement`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  validateData(){
    if (!this.anouncement.name){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Name');
      return false;
    }
    return true;
  }

}
